import React from 'react';
import { Link } from 'react-router-dom';

import styles from './footer.scss';

// eslint-disable-next-line import/no-webpack-loader-syntax, import/first, import/no-unresolved
import logoImage from '!file-loader!./assets/scandgate-white.svg';

const Footer = () => (
  <div className={styles.footer}>
    <nav className={styles.nav}>
      <Link to="/">Hem</Link>
      <Link to="/helpdesk/">Helpdesk</Link>
      <Link to="/kontakta-oss/">Kontakta oss</Link>
    </nav>

    <div className={styles.logoContainer}>
      <img src={logoImage} alt="ScandGate AB" className={styles.logo} />
    </div>

    <div className={styles.copyright}>
      &copy;&reg; {(new Date()).getFullYear()} ScandGate AB
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./blocks/Footer/index.js